var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "button",
      {
        staticClass: "btn btn-lg btn-link",
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            return _vm.$router.go(-1)
          },
        },
      },
      [
        _c("i", {
          staticClass: "fa fa-arrow-left",
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c("span", [_vm._v("Back")]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticStyle: {
          "min-width": "400px",
          width: "40vw",
          margin: "auto",
          "margin-top": "40px",
        },
      },
      [
        _c("h2", { staticClass: "fg-color-blue" }, [
          _vm._v(_vm._s(_vm.userSessionDetails?.DisplayName)),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("span", [_vm._v("Organization:")]),
          _vm._v(" "),
          _vm.userSessionDetails.OrganizationUnitId
            ? _c("strong", { staticClass: "fg-color-gray" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.userSessionDetails?.OrganizationUnitName) +
                    "\n            "
                ),
              ])
            : _vm.userSessionDetails.IsGlobalAdmin
            ? _c("strong", [
                _c(
                  "a",
                  {
                    attrs: {
                      href: `/#/admin/organizations/users/manage/organization/${_vm.userSessionDetails.UserId}`,
                    },
                  },
                  [_vm._v("None")]
                ),
              ])
            : _c("strong", [_vm._v("None")]),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("span", [_vm._v("Email:")]),
          _vm._v(" "),
          _c("strong", { staticClass: "fg-color-gray" }, [
            _vm._v(_vm._s(_vm.userSessionDetails.Email)),
          ]),
        ]),
        _vm._v(" "),
        _c("hr"),
        _c("br"),
        _vm._v(" "),
        _c("div", { staticClass: "border-box" }, [
          _c("h4", [_vm._v("My password")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "font-size": "16px" } }, [
            _vm._v(
              "You can change password by providing your one or reset it to let us generate one for you and send it to your email"
            ),
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-primary",
              attrs: {
                type: "button",
                href: "/#/organizations/users/changepassword",
              },
            },
            [_vm._v("Change password")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-secondary",
              attrs: { type: "button" },
              on: { click: _vm.handleResetPassword },
            },
            [_vm._v("Reset password")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "border-box" }, [
          _c("h4", [_vm._v("My sign-ins")]),
          _vm._v(" "),
          _c("p", { staticStyle: { "font-size": "16px" } }, [
            _vm._v(
              "Do you want do sign-out just from the current session or also from all other sessions on all other devices and browsers?"
            ),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { type: "button" },
              on: { click: _vm.handleSignoutFromSessionCommandV1 },
            },
            [_vm._v("Current session")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-secondary",
              attrs: { type: "button" },
              on: { click: _vm.handleSignoutFromAllSessionsCommandV1 },
            },
            [_vm._v("All my sessions")]
          ),
        ]),
        _vm._v(" "),
        _vm._m(0),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "border-box" }, [
      _c("h4", [_vm._v("Access tokens")]),
      _vm._v(" "),
      _c("p", { staticStyle: { "font-size": "16px" } }, [
        _vm._v("Manage your tokens for  API calls"),
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn btn-primary",
          attrs: { role: "button", href: "/#/organizations/accesstokens/my" },
        },
        [_vm._v("My tokens")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }